@if (searchTerm) {
  <mat-form-field
    class="display-flex"
    appearance="outline"
    [floatLabel]="floatLabel"
    [class.no-label]="!label"
  >
    <mat-label>{{ label }}</mat-label>
    <input
      type="text"
      placeholder="{{ placeholder | translate }} {{ label }}"
      matInput
      [formControl]="searchTerm"
      [matAutocomplete]="auto"
      [required]="required"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      class="app-ui-select"
      [displayWith]="nameof"
      (optionSelected)="onChange($event)"
    >
      @if (showList) {
        @for (option of filteredOptions | async; track option) {
          <mat-option
            [value]="option"
            [ngClass]="option.optionClass"
            (onSelectionChange)="onSelect($event, option)"
            (click)="search()"
          >
            @if (renderIcons) {
              <mat-icon>{{ option.name | translate }}</mat-icon>
            }
            {{ option.name | translate }}
            @if (option.optionSuffix) {
              ({{ option.optionSuffix | translate }})
            }
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
}
<div class="input-description">{{ description }}</div>
